import React, { useEffect, useState } from "react";
import "./listCard.scss";
import { IonCol } from "@ionic/react";
import { Link } from "react-router-dom";
import { utilService } from "../../../services";
import Call from "../Call/call";
import { unitDeptListService } from "../../../pages/UnitDeptList/UnitDept.service";

interface FavoriteRequest {
  Reg_code: string;
  siteId: string;
  fav: boolean;
  unitId?: number;
}

const UnitDeptListCardComponent = ({
  listData,
  componentName,
  parentSource,
  triggerList }: any) => {
  const [favorite, setFavoriteIcon] = useState(false);

  useEffect(() => {
    setFavoriteIcon(listData.fav);
  }, []);

  console.log(listData, "listData")

  const setFavorite = async (listData: any) => {
    setFavoriteIcon((value) => !value);
    var favBoolValue = listData.fav;
    const params: FavoriteRequest = {
      Reg_code: utilService.getNetwork(),
      siteId: listData.site,
      fav: favBoolValue,
      unitId: listData.unitId,
    };

    const respTeammatesList =
      await unitDeptListService.getUnitandDepartmentFavouriteList(
        params,
        listData.site
      );
    if (respTeammatesList.isSuccess && respTeammatesList.result) {
      triggerList();
      // setLoaderStatus(false);
    }
  };

  const setDataToCall = () => {
    return {
      callTo: parentSource,
      contactNumber: listData?.contactDetails
        ? listData.contactDetails[0].number
        : "",
      name: listData.name,
    };
  };

  return (
    <IonCol className="base-column" size="12" size-lg="2">
      <div
        className={
          listData.isAssigned !== false
            ? "list-card"
            : "list-card disabled-card"
        }
      >
         <div
          className={`content-wrapper ${
           "next-card"
          }`}
        >
          <div
            
          >
            <div className="input-data">
              <div className="item-title large-font" title={listData.unitName}>
                {listData.unitName}
              </div>
              <div
                className="item-sub-title small-font"
                title={listData.location}
              >
                {listData.location}
              </div>
              <div className="item-sub-title small-font">Site : {listData.site_name}</div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={
          listData.isAssigned !== false
            ? "fav-button"
            : "fav-button disabled-card"
        }
      >
        <div
          className={
            listData.fav !== false
              ? "input-icon icon-favorite_fill"
              : "input-icon icon-favorite"
          }
          onClick={(e: any) => {
            if (listData.fav == true) {
              listData.fav = false;
            } else {
              listData.fav = true;
            }
            setFavorite(listData);
          }}
        ></div>
      </div>

      <div
        className={
          listData.isAssigned !== false
            ? "call-button"
            : "call-button disabled-card"
        }
      >
        <Call
          selectedDoctorGuid=""
          dataFromParent={setDataToCall()}
          isAssignedNumber={true}
          isUnit={true}
          listData={listData}
        ></Call>
      </div>
    </IonCol>
  );
};

export default UnitDeptListCardComponent;
